import React from "react";
import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import EntityMultiTagInput from "common/views/tag/EntityMultiTagInput.view";

interface IRefineCategoryProps {
	selected: ID[];
	onChange: (ids: ID[]) => void;
	knowledgeBaseId: ID;
}

@Entity({
	many: 'kbCategory_many'
})
class Category {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}

export default function RefineCategory(props: IRefineCategoryProps) {

	return (
		<EntityMultiTagInput
			viewKey="refine.category"
			onChange={props.onChange}
			value={props.selected}
			entity={Category}
			getKey={(c) => c.id}
			getSearchParams={(query) => {

				return {
					query,
					sort: "name",
					knowledgeBaseId: props.knowledgeBaseId || null
				};
			}}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/panels/kb/category/RefineCategory.tsx